import { t } from '@grafana/i18n';
import React, { useCallback } from 'react';
import { AutoSizeInput } from '@grafana/ui';
import { getVariableControlId } from '../utils.js';

function VariableValueInput({ model }) {
  const { value, key, loading } = model.useState();
  const onBlur = useCallback(
    (e) => {
      model.setValue(e.currentTarget.value);
    },
    [model]
  );
  const onKeyDown = useCallback(
    (e) => {
      if (e.key === "Enter") {
        model.setValue(e.currentTarget.value);
      }
    },
    [model]
  );
  return /* @__PURE__ */ React.createElement(
    AutoSizeInput,
    {
      id: getVariableControlId(model.state.type, key),
      placeholder: t("grafana-scenes.variables.variable-value-input.placeholder-enter-value", "Enter value"),
      minWidth: 15,
      maxWidth: 30,
      value,
      loading,
      onBlur,
      onKeyDown
    }
  );
}

export { VariableValueInput };
//# sourceMappingURL=VariableValueInput.js.map
